import { useCallback, useMemo } from "react"
import "./Button.scss"
const Button = ({ type = 'PRIMARY', width = "max-content", onClick, loading, text, padding }) => {

    return (
        <div className={type === "SECONDARY" ? "SuvaiButtonSecondary" : "SuvaiButtonPrimary"}
            style={{ width, padding }}
            onClick={onClick}>
            {loading && <div className="Suvai-loader-btn" />}   {text}
        </div >

    )
}
export default Button